/**
 * Reglas de promociones compartidas por web (admin) y app (cliente).
 * promo_usage_limit = 0 → sin límite de usos. promo_validity vacío → sin vencimiento.
 */

export const PROMO_ADMIN_FIELDS = [
  'promo_name',
  'promo_description',
  'promo_code',
  'promo_discount_type',
  'promo_discount_value',
  'max_promo_discount_value',
  'min_order',
  'promo_validity',
  'promo_usage_limit',
  'promo_show',
  'createdAt',
];

const num = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : 0;
};

export const normalizePromoCode = (code) => String(code || '').trim().toUpperCase().replace(/\s+/g, '');

export const isPromoExpired = (promo, now = Date.now()) => {
  const until = Number(promo && promo.promo_validity);
  return Number.isFinite(until) && until > 0 && now > until;
};

export const isPromoExhausted = (promo) => {
  const limit = num(promo && promo.promo_usage_limit);
  return limit > 0 && num(promo.user_avail) >= limit;
};

/** 'active' | 'expired' | 'exhausted' | 'hidden' */
export const promoStatus = (promo, now = Date.now()) => {
  if (isPromoExpired(promo, now)) return 'expired';
  if (isPromoExhausted(promo)) return 'exhausted';
  if (!promo.promo_show) return 'hidden';
  return 'active';
};

/** Descuento en dinero para un monto; nunca supera el monto ni el tope del promo. */
export const computePromoDiscount = (promo, amount, decimals = 0) => {
  const total = num(amount);
  if (!promo || total <= 0) return 0;
  const value = num(promo.promo_discount_value);
  let discount;
  if (String(promo.promo_discount_type).toLowerCase() === 'percentage') {
    discount = (total * value) / 100;
    const cap = num(promo.max_promo_discount_value);
    if (cap > 0) discount = Math.min(discount, cap);
  } else {
    discount = value;
  }
  discount = Math.max(0, Math.min(discount, total));
  const factor = Math.pow(10, Number.isInteger(Number(decimals)) ? Number(decimals) : 0);
  return Math.round(discount * factor) / factor;
};

/** { ok: true } o { ok: false, reason: 'min_order' | 'exhausted' | 'used' | 'expired' } */
export const checkPromoEligibility = (promo, amount, uid, now = Date.now()) => {
  if (num(amount) < num(promo.min_order)) return { ok: false, reason: 'min_order' };
  if (isPromoExpired(promo, now)) return { ok: false, reason: 'expired' };
  if (isPromoExhausted(promo)) return { ok: false, reason: 'exhausted' };
  if (uid && promo.usersUsed && promo.usersUsed[uid]) return { ok: false, reason: 'used' };
  return { ok: true };
};

/** Datos del promo que se guardan en la reserva (sin contadores ni lista de usuarios). */
export const slimPromo = (promo) => ({
  id: promo.id,
  promo_code: promo.promo_code || '',
  promo_name: promo.promo_name || '',
  promo_discount_type: promo.promo_discount_type || '',
  promo_discount_value: num(promo.promo_discount_value),
  max_promo_discount_value: num(promo.max_promo_discount_value),
  min_order: num(promo.min_order),
});
